import { AccountTree, DataObject, Inventory2, SmartToy } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { StudioPanelMode, StudioRightPanelMode } from "modules/studio/types/studio-types";

const activityItems = [
    { id: "explorer", labelKey: "studio.activity.explorer", fallback: "Explorer", icon: <DataObject fontSize="small" /> },
    { id: "package", labelKey: "studio.activity.package", fallback: "Package", icon: <Inventory2 fontSize="small" /> },
    { id: "architecture", labelKey: "studio.activity.architecture", fallback: "Architecture", icon: <AccountTree fontSize="small" />, requiresAi: true },
    { id: "ai", labelKey: "studio.activity.ai", fallback: "AI", icon: <SmartToy fontSize="small" />, requiresAi: true },
];

type StudioActivityRailProps = {
    hasActiveAi: boolean;
    leftPanelMode: StudioPanelMode;
    rightPanelMode: StudioRightPanelMode;
    tt: (key: string, fallback: string) => string;
    onActivityClick: (activityId: string) => void;
};

const StudioActivityRail = ({
    hasActiveAi,
    leftPanelMode,
    rightPanelMode,
    tt,
    onActivityClick,
}: StudioActivityRailProps) => (
    <Box className="platform-studio__activity">
        {activityItems
            .filter((item) => !item.requiresAi || hasActiveAi)
            .map((item) => (
                <Tooltip key={item.id} title={tt(item.labelKey, item.fallback)} placement="right">
                    <IconButton
                        className={
                            (item.id === leftPanelMode || item.id === rightPanelMode)
                                ? "platform-studio__activity-button platform-studio__activity-button--active"
                                : "platform-studio__activity-button"
                        }
                        size="small"
                        onClick={() => onActivityClick(item.id)}
                    >
                        {item.icon}
                    </IconButton>
                </Tooltip>
            ))}
    </Box>
);

export default StudioActivityRail;
